import React from "react";
// import img from '../marketplaceassets/buildimg.png';
import "./IntegrationFaster.css";

export default function IntegrationFaster() {
  return (
    <div id="integration-faster" className="outsourcemainclass">
        <div className="overlay"></div>
      <div className="left">
        <h2 className="heading">
        Enable Faster, Smarter Development
        </h2>
        <p className="subheading">
       Empower your development teams with BastionEx’s Continuous Integration services. Build, test, and deliver applications with confidence—faster, safer, and more efficiently.
        </p>
        <button>Get started with BastionEx CI services today.</button>
      </div>
    </div>
  );
}
